import App from "@/App.vue";
import { createApp, h } from "vue";
import { createPinia } from "pinia";
import router from "@/router/index";
import environment from "@/environment";

// Axios
import axios from "axios";
import errorInterceptor from "@/tools/interceptor";

// Модуль личного кабинета.
import { useLK } from "@/controllerLK/LKstore.js";

// Директивы.
import clickOutside from "@/tools/directives/clickOutside.js";
import tooltip from "@/tools/directives/tooltip.js";
import focus from "@/tools/directives/focus.js";

// Основные стили.
import "@/assets/style/style.scss";

// Globus UI KIT
import GlobusUI from "@globus/ui-kit";
import "@globus/ui-kit/dist/globus-ui-kit.css";
import "@globus/ui-kit/themes/lk.css";
import "@globus/ui-kit/themes/globus.css";

const app = createApp({
    mounted() {
        console.log("[START] Start globus-main Application v ", process.env.VUE_APP_VERSION);
        localStorage.setItem("appVersion", process.env.VUE_APP_VERSION);
        const LKStore = useLK();
        window.LKAxios(axios, LKStore);

        errorInterceptor(axios);

        window.initRouterLK(LKStore);
        window.moduleInit(environment.settings, router, LKStore);

    },
    render: () => h(App)
});

const pinia = createPinia();

app.use(GlobusUI);

app.use(router);
app.use(pinia);

app.directive("tooltip", tooltip);
app.directive("focus", focus);
app.directive("clickOutside", clickOutside);

app.mount("#app");
